import { Loader2, Send } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { PROVIDERS, type Provider, type RenderCheck, type Result } from "./renderCheckTypes";

const resultBadge = (result: Result | null) => {
  if (result === "pass") return <Badge className="bg-green-600 text-white hover:bg-green-600">Pass</Badge>;
  if (result === "issue") return <Badge variant="secondary">Issue</Badge>;
  if (result === "fail") return <Badge variant="destructive">Fail</Badge>;
  return <Badge variant="outline">Untested</Badge>;
};

type RowProps = {
  row: { key: string; displayName: string; kind: "transactional" | "auth" };
  findCheck: (key: string, provider: Provider) => RenderCheck | null;
  sending: string | null;
  onOpenEdit: (key: string, provider: Provider) => void;
  onSendAll: (key: string) => void;
};

export const RenderCheckRow = ({ row, findCheck, sending, onOpenEdit, onSendAll }: RowProps) => (
  <tr className="border-t border-border">
    <td className="px-3 py-2">
      <div className="font-medium">{row.displayName}</div>
      <div className="text-xs text-muted-foreground">
        {row.key}
        {row.kind === "auth" && " · manual trigger"}
      </div>
    </td>
    {PROVIDERS.map((p) => {
      const c = findCheck(row.key, p);
      return (
        <td key={p} className="px-3 py-2">
          <button
            type="button"
            className="flex flex-col items-start gap-1 rounded px-1 py-0.5 text-left hover:bg-muted"
            onClick={() => onOpenEdit(row.key, p)}
          >
            {resultBadge((c?.result as Result | null) ?? null)}
            {c?.reviewed_at && (
              <span className="text-[10px] text-muted-foreground">
                {new Date(c.reviewed_at).toLocaleDateString()}
              </span>
            )}
          </button>
        </td>
      );
    })}
    <td className="px-3 py-2 text-right">
      {row.kind === "transactional" ? (
        <Button variant="outline" size="sm" disabled={sending !== null} onClick={() => onSendAll(row.key)}>
          {sending?.startsWith(`${row.key}:`) ? (
            <Loader2 className="h-3 w-3 animate-spin" />
          ) : (
            <Send className="h-3 w-3" />
          )}
          Send to all
        </Button>
      ) : (
        <span className="text-xs text-muted-foreground">Trigger via /auth</span>
      )}
    </td>
  </tr>
);
